// export type EventHandler = (event: UniversalEvent) => void;

export var EntityType = /*#__PURE__*/function (EntityType) {
  EntityType["NODE"] = "node";
  EntityType["COMPONENT"] = "component";
  EntityType["WINDOW"] = "window";
  return EntityType;
}({});